//initial redux
import { put, call, takeEvery, fork, all, take, select } from "redux-saga/effects";
import * as router from "react-router-redux";
import { eventChannel, delay } from "redux-saga";
import reportsservice from "../../../../services/reports";
import moment from "moment";
import pointsservice from "../../../../services/points";
import pointName from "../../../../utils/pointName";

const initialState = {
};



/////////
//types
export const types = {
	LOAD_DATA: "components/percentageoutsiderangechart/LOAD_DATA",
};

///////////
//reducers
export const reducers = {
	reducer(state = initialState, action) {
		switch (action.type) {
			case types.LOAD_DATA:{
				return state;
			}
			default:
				return state;
		}
	}
};

function* getPointNames(pointRangeData){
	let pointNames = [];

	let pointIds = [];
	pointRangeData.forEach(pointRange => {
		pointIds.push(pointRange.pointId);
	});
	const pointDetails = yield all(pointIds.map(pointId => call(pointsservice.TrendableObjectGetObject, pointId)));
	if(pointDetails instanceof Error || !pointDetails){return;}
	pointDetails.forEach(point => {
		pointNames.push({
			name: point.name,
			pointId: point.objectID,
			description: point.description,
		});
	});

	return pointNames;
}

function addColumns(chart, pointRangeData, pointNames){
	if(!chart.options){return;}
	let series = {
		type: 'column',
		data: [],
		dataLabels: {
			enabled: true,
			crop: false,
			overflow: 'none',
			format: '{y:,.1f}%'
		},
		tooltip: {
			pointFormat: '<span style="color:{point.color}">\u25CF</span> <b>{point.y:,.1f}%</b><br/>'
		},
	};
	pointRangeData.forEach(pointRange => {
		let matchingPoint = pointNames.find(names => names.pointId == pointRange.pointId);
		let name = pointName.formatDescription(matchingPoint);
		series.data.push({
			name: name,
			y: pointRange.percent
		});
	});
	chart.addSeries(series);
}

//////////
//sagas
export const sagas = {
	*rootSaga() {
		yield all([this.loadData()]);
    },

	*loadData(){
		yield takeEvery(types.LOAD_DATA, function*({payload}){
			const component = payload.component;
			const chart = payload.chart;
			const ruleInstanceId = component.ruleInstanceId;
			const fromDate = moment(payload.timePeriod.startDate);
			const toDate = moment(payload.timePeriod.endDate);
			const pointRangeData = yield call(reportsservice.GetPercentageOutsideRange, ruleInstanceId, fromDate, toDate);
			if(pointRangeData instanceof Error || !pointRangeData){return;}
			const pointNames = yield call(getPointNames, pointRangeData);
			addColumns(chart, pointRangeData, pointNames);
			if(payload.onLoadComplete){
				payload.onLoadComplete();
			}
		});
	},
};

////////
//actions
export const actions = {
	loadData(component, chart, timePeriod, onLoadComplete){
		return {
			type: types.LOAD_DATA,
			payload: {component, chart, timePeriod, onLoadComplete}
		};
	},
};



// WEBPACK FOOTER //
// ./src/components/ReportComponents/Charts/PercentageOutsideRangeChart/redux.js